import axios from '../index'
export default {
    
    getInstitucion (params) {
        return axios.get('/instituciones/usuario/', {
            params
        })
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getReglasCobro(params){
        return axios.get('/reglas-de-cobro/filtrar', {params})
    },
    getProgramas (institucionId) {
        return axios.get('/programas/institucion/' + institucionId)
    },
    getNivelAcademico (params) {
        return axios.get('/niveles-academicos/filtrar', {params})
    },
    getTiposAlumnoReglas(){
        return axios.get('/reglas-de-cobro/tipos-de-alumnos/listado')
    },
    getCodigoDetalleReglas(params){
        return axios.get('/codigos-de-detalle/listado', {params})
    },
    getFechaVigenciaReglas(params){
        return axios.get('/fechas-de-vigencia/filtrar', {params})
    },
    postCrearReglasCobro(formData){
        return axios.post('/reglas-de-cobro/guardar', formData)
    },
    postEditarReglasCobro(formData){
        return axios.post('/reglas-de-cobro/actualizar', formData)
    },
    postEliminarReglaCobro(id, formData){
        return axios.post('/reglas-de-cobro/destroy/' + id, formData)
    },
    postCopiarRegla(payload){
        return axios.post('/reglas-de-cobro/copiar', payload)
    },
    
}